import { MbUserAddressAdapter } from './mb-user-address.adapter'
import { Injectable } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class MbUserAddressConnector {

  constructor (protected adapter: MbUserAddressAdapter) {
  }

  getAll (userId: string) {
    return this.adapter.loadAll(userId)
  }
}
